import type { ContentfulButton } from "@scott/contentful/types";

/** Analytics identity of a promoted banner (hero or slider slide). */
export interface PromotionTracking {
  /** Cloudinary asset name of the banner image, falling back to its public_id. */
  creativeName?: string;
  /** Contentful internal name, as written. */
  name: string;
}

export type PromotionType = "hero" | "slider";

/**
 * Data attributes read by the D2C homepage tracker to fire view_promotion and
 * select_promotion. Slides pass their 1-based position; standalone banners
 * omit it and are numbered by the tracker in page order.
 */
export function promotionAttributes(
  tracking: PromotionTracking | undefined,
  type: PromotionType,
  position?: number
): Record<string, string> | undefined {
  if (!tracking?.name) {
    return;
  }

  return {
    "data-promo-name": tracking.name,
    "data-promo-type": type,
    ...(tracking.creativeName && {
      "data-promo-creative": tracking.creativeName,
    }),
    ...(position !== undefined && { "data-promo-position": String(position) }),
  };
}

/** Marks a call-to-action so a click on it is reported as select_promotion. */
export function ctaAttributes(
  button: Pick<ContentfulButton, "linkTarget" | "linkType">
): Record<string, string> {
  return {
    "data-promo-cta": "",
    ...(button.linkTarget && { "data-link-target": button.linkTarget }),
    ...(button.linkType && { "data-link-type": button.linkType }),
  };
}
